import React, { useState } from "react";
import { toast } from "sonner";
import { Package } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/download";

export const PackageFields = ({ value, onChange }) => (
  <div className="grid md:grid-cols-2 gap-4 items-end" data-testid="package-fields">
    <label className="flex items-center gap-3 text-sm font-semibold cursor-pointer">
      <input type="checkbox" checked={!!value.packageAvailable} onChange={(e) => onChange({ ...value, packageAvailable: e.target.checked })} data-testid="package-available-toggle" className="w-5 h-5 accent-[#0D2B5A]"/>
      Disponibile per pacchetti Evento Chiavi in Mano
    </label>
    <label className="text-sm">
      <span className="block font-semibold mb-1">Commissione al portale sui pacchetti (min. 10%)</span>
      <input type="number" min="10" max="90" step="0.5" value={value.packageCommission ?? 10} onChange={(e) => onChange({ ...value, packageCommission: e.target.value === "" ? "" : parseFloat(e.target.value) })}
        data-testid="package-commission-input" className="w-full border border-slate-300 rounded-xl px-4 py-2.5 focus:outline-none focus:border-gold text-sm"/>
    </label>
  </div>
);

export const PackageSettingsCard = () => {
  const { user, refresh } = useAuth();
  const [v, setV] = useState({ packageAvailable: !!user.packageAvailable, packageCommission: user.packageCommission ?? 10 });
  const save = async () => {
    if (!(v.packageCommission >= 10)) { toast.error("La commissione minima è 10%"); return; }
    try { await api.patch("/me", v); await refresh(); toast.success("Impostazioni pacchetti salvate"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-8 card-premium p-6" data-testid="package-settings-card">
      <h3 className="font-display text-xl font-bold flex items-center gap-2 mb-1"><Package className="w-5 h-5 text-gold"/>Pacchetti Evento Chiavi in Mano</h3>
      <p className="text-sm text-slate-600 mb-4">Chi è disponibile viene proposto per primo ai committenti; a parità, prima chi riconosce la commissione più alta. La commissione viene trattenuta dal tuo cachet quando il portale riceve il pagamento.</p>
      <PackageFields value={v} onChange={setV}/>
      <button onClick={save} data-testid="package-settings-save" className="btn-pill-gold text-sm mt-4">Salva</button>
    </div>
  );
};
